"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = __importDefault(require("../scss/colors"));
require("../scss/Slider.scss");
const StyledSlider = styled_components_1.default.input `
    ${(props) => props.isLocked
    ? "pointer-events: none; opacity: 0.5; filter: grayscale(1);"
    : ""}
    background: linear-gradient(90deg, ${(props) => props.fillColor} ${(props) => props.percentage}%, ${colors_1.default.grey2} ${(props) => props.percentage + 0.1}%) !important;
    width: ${(props) => (props.label ? "calc(100%-180px)" : "100%")};
`;
const Value = styled_components_1.default.div `
    padding: 8px;
    border-radius: 4px;
    margin-right: 8px;
    margin-top: 2px;
    background: #2c3e50;
    display: inline-block;
    position: relative;
    color: white;
    &:after {
        content: " ";
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid #2c3e50;
    }
`;
class Slider extends react_1.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (react_1.default.createElement("div", { className: "range-slider", style: { position: "relative" } },
            react_1.default.createElement(StyledSlider, { type: "range", id: "start", name: this.props.name, className: "range-slider__range", step: this.props.step, min: this.props.min, max: this.props.max, value: this.props.value, onInput: this.props.onInput, onChange: this.props.onInput, onMouseUp: this.props.onPointerUp, fillColor: this.props.fillColor || colors_1.default.green1, isLocked: this.props.isLocked, percentage: (100 * (this.props.value - this.props.min)) /
                    (this.props.max - this.props.min), "data-test-label": this.props["data-test-label"] }),
            this.props.displayValue && (react_1.default.createElement(Value, null,
                this.props.value,
                this.props.units)),
            this.props.label && react_1.default.createElement("label", null, this.props.label),
            this.props.children));
    }
}
exports.Slider = Slider;
exports.default = Slider;
